var SharedRichCardEvents;

(function (SharedRichCardEvents) {
  SharedRichCardEvents["VIEW_SELLABLE"] = "VIEW_SELLABLE";
  SharedRichCardEvents["VIEW_SELLABLE_TOP_LIST"] = "VIEW_SELLABLE_TOP_LIST";
})(SharedRichCardEvents || (SharedRichCardEvents = {}));

export { SharedRichCardEvents };
//# sourceMappingURL=index.js.map
